<template>
   <v-layout column>
      <v-flex column id="gridHeaderSlot" lg12 v-if="$slots.gridHeader || hasPageFilters" xs12>
         <filter-row></filter-row>

         <slot name="gridHeader"></slot>
      </v-flex>
      <v-flex lg12 style="position: relative" xs12>
         <div id="dxGrid" style="border-radius: 8px"></div>
         <div id="gridFooter">
            <slot name="gridFooter"></slot>
         </div>
      </v-flex>
   </v-layout>
</template>

<script>
   import FilterRow from '../defaultPage/FilterRow';
   export default {
      name: 'crud-grid',
      components: { FilterRow },
      props: {
         api: {
            type: String,
            required: false,
            default: 'dataService'
         },
         obj: {
            type: String,
            required: false
         },
         data: {
            type: Array,
            required: false,
            default: () => []
         },
         datakeyName: {
            type: String,
            required: false,
            default: () => 'id'
         },
         filterBy: {
            type: Object,
            required: false
         },
         columns: {
            type: Array,
            required: false,
            default: () => null
         },
         settings: {
            type: Object,
            required: false,
            default: (val) => {
               let ret = {
                  noNew: false,
                  noRefresh: false,
                  noSearch: false,
                  noExport: true,
                  noChooser: false,
                  noGroup: false,
                  multiSelectable: false
               };
               return Object.assign({}, ret, val || {});
            }
         },
         noControls: {
            type: Boolean,
            required: false,
            default: () => false
         },
         options: {
            type: Object,
            required: false,
            default: (val) => Object.assign({}, { newLabel: null }, val || {})
         }
      },
      data () {
         return {
            gridData: null,
            gridInstance: null,
            pageSize: 15
         };
      },
      watch: {
         filterBy: {
            handler: function () {
               // if ((filter.hasOwnProperty('apply') && filter.apply) || (!filter.hasOwnProperty('apply')))
               this.gridInstance.refresh();
            },
            deep: true
         }
      },
      computed: {
         hasPageFilters () {
            return this.$store.getters.hasFilters;
         },
         selectedStoreId () {
            return this.$store.state.company.selectedStore;
         },
         selectedStoreName () {
            return this.$store.state.company.selectedStoreName;
         }
      },
      methods: {
         storeChanged (data) {
            let newValue = data.id;
            // console.log('Store Changed Event', this.obj);
            if (this.gridData && this.gridData.length && (this.gridData[0].hasOwnProperty('storeName') || this.gridData[0].hasOwnProperty('companyId'))) {
               if (newValue > 0) {
                  // console.log('StoreID: ', newValue);
                  let storeName = this.selectedStoreName;
                  let ds = this.gridData.filter((v) => ((v.companyId && v.companyId === newValue) || (v.storeName && v.storeName === storeName)));
                  let storeGroupIndex = 0;
                  let colsChange = this.columns.map((item) => {
                     if (item.dataField === 'storeName') {
                        storeGroupIndex = item.groupIndex;
                        item.visible = false;
                        item.groupIndex = undefined;
                     } else if (item.groupIndex && item.groupIndex > storeGroupIndex) {
                        item.groupIndex--;
                     }
                     // console.log(JSON.stringify(item));
                     return item;
                  });
                  this.gridInstance.option('columns', colsChange);
                  this.gridInstance.option('dataSource', ds);
               } else if (newValue === 0) {
                  let ds = this.gridData;
                  let colsChange = this.columns.map((item) => {
                     if (item.dataField === 'storeName') {
                        item.visible = true;
                        item.groupIndex = 0;
                     } else if (item.groupIndex >= 0) {
                        item.groupIndex++
                     }
                     // console.log(JSON.stringify(item));
                     return item;
                  });
                  this.gridInstance.option('columns', colsChange);
                  this.gridInstance.option('dataSource', ds);
               }
            }
         },
         refresh () {
            this.gridInstance.clearSelection();
            this.gridInstance.refresh();
         },
         deleteRow (key) {
            let ds = this.gridData.filter((v) => v[this.datakeyName] !== key);
            this.gridData = ds;
            this.gridInstance.option('dataSource', ds);
         },
         updateRow (key, values) {
            console.log(this.obj, key, values);
            return this.$api[this.api].save(this.obj, values, key);
         },
         gridHeight (size = 0) {
            let wH = window.innerHeight;
            let gH = ($('#gridHeaderSlot').height() || 0);
            let tH = ($('.app--toolbar').height() || 0);
            return Math.floor(wH - tH - gH - 40);
         },
         ghResize (size) {
            let h = this.gridHeight(size);
            // console.log('Avail H:', h, this.gridInstance.option('height'));
            if (this.gridInstance && this.gridInstance.option('height') !== h) {
               this.gridInstance.option('height', h);
            }
         }
      },
      mounted () {
         // console.log(this);
         let self = this;
         let h = self.gridHeight();
         let ps = Math.floor((h - 40 - 47 - 40) / 35);
         let uCanExport = this.$uCan({ op: 'X' });
         let uCanInsert = this.$uCan({ op: 'I' });
         let uCanUpdate = this.$uCan({ op: 'U' });
         let dataSource = new DevExpress.data.CustomStore({
            key: this.datakeyName,
            onLoaded: (data) => {
               this.$emit('onDataLoaded', JSON.parse(JSON.stringify(data)));
            },
            load: (loadOptions) => {
               // console.log('loading: ', this.filterBy);
               let params = {};
               // let pageFilters = (this.pageFilters && this.pageFilters.filters) ? this.pageFilters.filters : {};
               params.filterBy = Object.assign({}, loadOptions.filter || {}, this.filterBy || {});
               params.sortBy = loadOptions.sort ? loadOptions.sort : '';
               params.skipBy = loadOptions.skip;
               params.pgQty = this.pageSize;
               if (loadOptions.searchValue) {
                  params.searchValue = loadOptions.searchValue;
                  params.searchOperation = loadOptions.searchOperation;
                  params.searchExpr = loadOptions.searchExpr;
               }
               return new Promise((resolve, reject) => {
                  if (!this.data.length) {
                     this.$api[this.api].search(this.obj, params)
                        .then((data) => {
                           let gridData = (typeof data === 'object' && data !== null && data.hasOwnProperty('main')) ? (data.main || []) : (data || []);
                           let ds = gridData;
                           // console.log(ds);
                           //Filter selected store
                           if (this.selectedStoreId > 0 && ds.length &&
                              (gridData[0].hasOwnProperty('storeName') || gridData[0].hasOwnProperty('companyId'))) {
                              let id = this.selectedStoreId;
                              let storeName = this.selectedStoreName;
                              ds = gridData.filter((v) => ((v.companyId && v.companyId === id) || (v.storeName && v.storeName === storeName)));
                           }
                           // console.log(ds);
                           resolve(ds, { totalCount: (ds) ? ((ds.totalCount) ? ds.totalCount : ds.length) : 0 });
                           this.gridData = gridData;
                        })
                        .catch((err) => reject(err));
                  } else {
                     let data = this.data;
                     resolve(data, { totalCount: (data.totalCount) ? data.totalCount : data.length });
                  }
               });
            },
            update: (key, values) => {
               return this.$api[this.api].save(this.obj, values, key);
            }
         });
         let gridOptions = () => {
            let cols = self.columns;
            if (self.selectedStoreId > 0) {
               cols.map((item) => {
                  if (item.dataField === 'storeName') {
                     item.visible = false;
                     item.groupIndex = undefined;
                  }
               });
            }
            let newLabel = (self.options && self.options.newLabel) ? self.options.newLabel : self.$t('appMsg.create');
            if (window.innerWidth <= 480) newLabel = '+';
            return {
               dataSource: dataSource,
               columns: cols,
               noDataText: self.$t('appMsg.gridNoDataCrud').format(newLabel),
               visible: true,
               allowColumnReordering: true,
               errorRowEnabled: false,
               loadPanel: {
                  text: self.$t('appMsg.loading')
               },
               rowAlternationEnabled: true,
               hoverStateEnabled: true,
               columnHidingEnabled: false,
               sorting: {
                  mode: 'single'
               },
               height: h,
               editing: {
                  allowAdding: false,
                  allowUpdating: false,
                  allowDeleting: false,
                  texts: {
                     addRow: 'New' + self.title,
                     saveRowChanges: 'OK',
                     confirmDeleteMessage: ''
                  }
               },
               paging: {
                  pageSize: ps
               },
               scrolling: {
                  mode: 'virtual',
                  preloadEnabled: false
               },
               pager: {
                  infoText: self.$t('appMsg.pagerText'),
                  showInfo: (window.innerWidth > 480),
                  showNavigationButtons: false,
                  showPageSizeSelector: false,
                  visible: true
               },
               searchPanel: {
                  visible: (!self.settings.noSearch && !self.noControls),
                  placeholder: self.$t('appMsg.search') + '...',
                  width: (window.innerWidth > 480) ? 240 : 120
               },
               selection: {
                  mode: 'single',
                  showCheckBoxesMode: 'always'
               },
               filterRow: {
                  showOperationChooser: false,
                  visible: false
               },
               remoteOperations: {
                  filtering: false,
                  grouping: false,
                  paging: false,
                  sorting: false,
                  summary: false
               },
               columnChooser: {
                  enabled: (!self.settings.noChooser && !self.noControls),
                  height: 280,
                  width: 300,
                  emptyPanelText: self.$t('appMsg.emptyChooserPanel'),
                  title: self.$t('appMsg.availableColumns')
               },
               export: {
                  enabled: (!self.settings.noExport && !self.noControls && uCanExport)
               },
               groupPanel: {
                  allowColumnDragging: true,
                  visible: (!self.settings.noGroup && !self.noControls),
                  emptyPanelText: self.$t('appMsg.groupHere')
               },
               onRowClick: function (e) {
                  // console.log(e);
                  if (e.rowType === 'data' && uCanUpdate) {
                     self.$emit('onRowClick', JSON.parse(JSON.stringify(e.data)));
                  }
               },
               onSelectionChanged: function (selectedItems) {
                  if (self.settings.multiSelectable && self.gridInstance.option('selection.mode') === 'multiple') {
                     let data = JSON.parse(JSON.stringify(selectedItems.selectedRowsData));
                     let keys = selectedItems.selectedRowKeys;
                     self.$emit('onSelectionChange', {
                        data,
                        keys
                     });
                  }
               },
               onToolbarPreparing: function (e) {
                  e.toolbarOptions.visible = !self.noControls;
                  e.toolbarOptions.items.unshift(
                     /*{
                        location: "before",
                        widget: "dxButton",
                        visible: (!self.settings.noRefresh && (window.innerWidth > 480)),
                        options: {
                           icon: 'pulldown',
                           hint: 'Exibir Cancelados',
                           onClick: (e) => {
                              self.gridInstance.refresh();
                              self.$emit('onRefreshClick');
                           }
                        }
                     },
                     {
                        location: "before",
                        widget: "dxButton",
                        visible: (!self.settings.noSearch && (window.innerWidth > 480)),
                        options: {
                           icon: 'filter', //or your custom icon
                           hint: 'Filtrar por Coluna',
                           onClick: function () {
                              self.gridInstance.clearFilter();
                              self.gridInstance.option('filterRow.visible', !self.gridInstance.option('filterRow.visible'));
                              self.gridInstance.repaint();
                           }
                        }
                     },*/
                     {
                        location: 'before',
                        widget: 'dxButton',
                        visible: (self.settings.multiSelectable),
                        options: {
                           icon: 'check', //or your custom icon
                           hint: self.$t('appMsg.selectMany'),
                           onClick: function () {
                              let options = self.gridInstance.option('selection');
                              let activated = options.mode === 'single';
                              self.gridInstance.clearSelection();
                              if (options.mode !== 'multiple') {
                                 Object.assign(options, {
                                    mode: 'multiple',
                                    allowSelectAll: true,
                                    showCheckBoxesMode: 'always'
                                 });
                              } else {
                                 Object.assign(options, {
                                    mode: 'single',
                                    allowSelectAll: false
                                 });
                              }
                              self.gridInstance.option('selection', options);
                              if (activated) {
                                 self.gridInstance.columnOption('command:select', 'width', 40);
                                 // self.gridInstance.option("columns[0].fixed", true);
                                 self.gridInstance.updateDimensions();
                              }
                           }
                        }
                     });
                  if (uCanInsert) {
                     e.toolbarOptions.items.unshift(
                        {
                           location: 'before',
                           widget: 'dxButton',
                           visible: (!self.settings.noNew),
                           options: {
                              text: (window.innerWidth > 480) ? newLabel : '',
                              icon: (window.innerWidth > 480) ? '' : 'add',
                              onClick: function () {
                                 self.gridInstance.clearSelection();
                                 self.$emit('onNewClick');
                              }
                           }
                        });
                  }
               },
               /*onCellPrepared: function (e) {
     
                 if (e.rowType === "data" && e.column.name === "command") {
                   console.log(e);
                   let printCommand = e.cellElement.find(".print");
                   console.log(printCommand);
                   $(printCommand).attr('onclick', );
                 }
               },*/
               onContextMenuPreparing: function (e) {
                  if (e.target === 'content' && self.options && self.options.contentMenu) {
                     self.options.contentMenu(e);
                  } else if (e.target === 'header' && self.options && self.options.headerMenu) {
                     self.options.headerMenu(e);
                  } else if (e.target === 'footer' && self.options && self.options.footerMenu) {
                     self.options.footerMenu(e);
                  }
               }
            };
         };
         let options = Object.assign({}, gridOptions(), this.options || {});
         this.gridInstance = $('#dxGrid').dxDataGrid(options).dxDataGrid('instance');
         this.pageSize = ps;
         window.getApp.$on('APP_MAIN_CONTENT_RESIZE', this.ghResize);
         window.getApp.$on('SELECTED_STORE_CHANGED', this.storeChanged);
      },
      beforeDestroy () {
         window.getApp.$off('APP_MAIN_CONTENT_RESIZE', this.ghResize);
         window.getApp.$off('SELECTED_STORE_CHANGED', this.storeChanged);
      }
   };
</script>

<style scoped>
   #gridHeaderSlot {
      position: relative;
   }
   #gridFooter {
      position: relative;
      margin-top: -50px;
      z-index: 2;
      padding-left: 0 !important;
      min-height: 40px;
      max-width: 60%;
   }
</style>


// WEBPACK FOOTER //
// node_modules/@consigmais-team/vue-common/layout/crudPage/crudGrid.vue